import { Component, Vue } from "vue-property-decorator";
import Product from './parts/product.vue';
import MainProduct from './parts/main-product.vue';
import Blog from './parts/blog.vue';
import user_module from '@/modules/user';
import VueStickyDirective from '@renatodeleao/vue-sticky-directive';
import FreeProducts from './parts/free-products.vue';

Vue.use(VueStickyDirective)

@Component({
  components: {
    Product,
    MainProduct,
    Blog,
    FreeProducts
  }
})

export default class Products extends Vue {

  play: boolean = false
  stickyOptions: any ={
    topSpacing: 65
  }
  blogClass: string = '';

  get isMobile(){

    return user_module.isMobile;
  }
  
  get sites(){

    return user_module.currentSites

  }

  get userProductsLabels(){

    return this.sites.map((site: any) => site.id);
  }

  get mainProducts(){

    const mainProduct = user_module.userProducts.filter(product => product.main && !product.free);

    return mainProduct || {};

  }
  get userProducts(){

    return user_module.userProducts.filter(product => !product.main && !product.free && !product.hide);
    
  }

  get freeProducts(){

    return user_module.userProducts.filter(product => !product.main && product.free && !product.hide);

  }


  handleScroll(){

    const products: any = this.$refs.products;
    const blog: any = this.$refs.blog;
    const {top, height} = products.getBoundingClientRect();
    const blogHeight = blog.$el.getBoundingClientRect().height;
    const bottomBorderDetect = height + top < blogHeight + 125;

    if (top < 60 && !bottomBorderDetect){

      this.blogClass = 'fixed-blog';
      
    } else if (bottomBorderDetect){

      this.blogClass = 'bottom-blog';

    } else {

      this.blogClass = '';
    }


  }

  mounted(){

    window.addEventListener('scroll', this.handleScroll);

  }

  beforeDestroy(){

    window.removeEventListener('scroll', this.handleScroll);
  }

}